import { BGM_TRACKS, type GameBgmId } from "./bgmTracks.js";
import { createMp3BgmPlayer } from "./createMp3BgmPlayer.js";
import { setBgmVolume } from "../mixSettings.js";

const PLAYERS = Object.fromEntries(
  BGM_TRACKS.map((track) => [track.id, createMp3BgmPlayer(track.url)]),
) as Record<GameBgmId, ReturnType<typeof createMp3BgmPlayer>>;

export function startBgm(id: GameBgmId): Promise<boolean> {
  return PLAYERS[id].start();
}

export function stopBgm(id: GameBgmId): void {
  PLAYERS[id].stop();
}

export function stopOtherBgm(keep: GameBgmId | null): void {
  BGM_TRACKS.forEach((track) => {
    if (track.id !== keep) PLAYERS[track.id].stop();
  });
}

export function stopAllBgm(): void {
  stopOtherBgm(null);
}

/** Updates the currently playing track without interrupting it. */
export function setGameBgmVolume(volume: number): number {
  const next = setBgmVolume(volume);
  Object.values(PLAYERS).forEach((player) => player.setVolume(next));
  return next;
}
